<script setup lang="ts">
import { computed } from "vue";
import Button from "@/components/Reusables/Buttons/Button.vue";

import { BuildingProjectType } from "@/features/BuildingProject";
import LoadingSpinner from "@/components/Reusables/Loading/LoadingSpinner.vue";

import { useModalStore } from "@/stores/modals/modals.store";

const modals = useModalStore();

const props = defineProps<{
  project: BuildingProjectType;
  isCompleted: boolean;
}>();

const isCompletedState = computed(() => props.isCompleted);

const buttonLabel = computed(() => {
  if (isCompletedState.value) return "Close";

  return "Dismiss";
});

const label = computed(() => {
  if (isCompletedState.value) return "Import Complete";

  return "Processing IFC file...";
});

const description = computed(() => {
  if (isCompletedState.value)
    return "All done! Your IFC file has been processed and your project has been updated automatically.";

  return "You can keep using the app while we work — we’ll automatically update your project when everything’s ready.";
});
</script>

<template>
  <div size="h-fit">
    <h4>{{ label }}</h4>
    <div class="flex flex-col items-center justify-center gap-6 py-4 text-center">
      <p class="text-type-muted w-[500px] text-sm">
        {{ description }}
      </p>
      <LoadingSpinner
        v-if="!isCompletedState"
        size="w-10 h-10"
        fill="primary" />
      <font-awesome-icon
        v-else
        icon="fa-solid fa-check"
        class="text-app-green-600 h-12 w-12" />
    </div>

    <div class="flex w-full justify-end">
      <Button
        color="button"
        :label="buttonLabel"
        @click="modals.close()" />
    </div>
  </div>
</template>
